import React from 'react';
import classNames from 'classnames';
import styles from './BtnList.module.css';
import { IBtnListProps } from './BtnList.type';

export const BtnList: React.FC<IBtnListProps> = ({ children, className }) => {
  return <div className={classNames(styles.btnList, className)}>{children}</div>;
};
